import React from 'react';
import { FiX, FiPhone, FiMail } from 'react-icons/fi';
import '../styles/ContactModal.css';

const ContactModal = ({ agentInfo, onClose, show, isMobile }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-button" onClick={onClose}>
          <FiX />
        </button>
        <img src="/images/rmxballoons.png" alt="Balloon Logo" className="modal-balloon-logo" />
        <div className="modal-contact-header">
          <h3 className="modal-agent-name">John Snippen</h3>
          <p className="modal-agent-company">REMAX Key Properties</p>
          {isMobile && (
            <img
              src="/images/JSlogo.png"
              alt="John Snippen Logo"
              className="modal-js-logo"
            />
          )}
          <p className="modal-agent-title">Principal Broker</p>
        </div>

        {agentInfo ? (
          <>
            {/* Static name and company are now above, in modal-contact-header */}
            {agentInfo.phone && (
              <p className="contact-info-item">
                <FiPhone className="contact-icon" />
                <a href={`tel:${agentInfo.phone}`}>{agentInfo.phone}</a>
              </p>
            )}
            {agentInfo.email && (
              <p className="contact-info-item">
                <FiMail className="contact-icon" />
                <a href={`mailto:${agentInfo.email}`}>{agentInfo.email}</a>
              </p>
            )}
          </>
        ) : (
          <p>Contact information is not available.</p>
        )}
        {isMobile && (
          <p className="modal-copyright-text">
            &copy; {new Date().getFullYear() === 2025 ? '2025' : `2025-${new Date().getFullYear()}`} Statusbond. All rights reserved.
          </p>
        )}
      </div>
    </div>
  );
};

export default ContactModal;
